import { apiClient } from './client'
import type { BrowsePage, BrowseSort } from './types'

export interface BrowseQuery {
  q?: string
  sort?: BrowseSort
  page?: number
  size?: number
  /** Phase 19: filter to a single community by slug. Unknown slug returns an empty page. */
  community?: string
}

export const fetchBrowse = async (query: BrowseQuery = {}): Promise<BrowsePage> => {
  const response = await apiClient.get<BrowsePage>('/api/v1/browse', {
    params: {
      ...(query.q ? { q: query.q } : {}),
      ...(query.community ? { community: query.community } : {}),
      sort: query.sort ?? 'recent',
      page: query.page ?? 0,
      size: query.size ?? 20,
    },
  })
  return response.data
}
